// Keeps the cart drawer's checkout button price in sync when a third-party
// app (e.g. a cart upsell widget) modifies the cart without going through
// this theme's own add-to-cart flow, which is the only code path that
// normally refreshes the drawer's contents.
(() => {
  if (window.cartDrawerPriceSyncInstalled) return;
  window.cartDrawerPriceSyncInstalled = true;

  let syncTimer = null;

  function getOpenDrawer() {
    const cartDrawer = document.querySelector('cart-drawer');
    return cartDrawer && cartDrawer.classList.contains('active') ? cartDrawer : null;
  }

  function syncCartDrawer() {
    const cartDrawer = getOpenDrawer();
    if (!cartDrawer || typeof cartDrawer.renderContents !== 'function') return;
    fetch(`${window.location.pathname}?sections=cart-drawer,cart-icon-bubble`)
      .then((response) => response.json())
      .then((sections) => cartDrawer.renderContents({ sections }))
      .catch((error) => console.error(error));
  }

  document.addEventListener('click', () => {
    if (!getOpenDrawer()) return;
    clearTimeout(syncTimer);
    syncTimer = setTimeout(syncCartDrawer, 900);
  }, true);
})();
